<template>
<div class="line-gallery-item" v-for="image in content" :key="image" v-bind:style="{ flexGrow: 1 }">
    <img v-bind:src="this.baseUrl+getImagePath(image)" />
    <p class="caption" v-if="image.caption">{{image.caption[currentLocalize]}}</p>
</div>
</template>

<script>
export default {
  name: "LineGallerySection",
  props: {
    content: Array,
    currentLocalize: String,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  methods:{
    getImagePath: function(image){
      if(image.translated == true)
        return image.path[this.currentLocalize];
      else
        return image.path;
    },
  }
}
</script>

<style>
    .line-gallery-item{
        display: inline-block;
        align-self: center;
        padding: 0px 5px;
    }
    .line-gallery-item > img{
      max-width: 100%;
    }
    .line-gallery-item > p{
        color: black;
        font-weight: 500;
        margin: 0.2em;
        height: 1.6em;
        overflow-y: visible;
        font-size: 0.9em;

    }
</style>